<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Terms &#38; Conditions</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Terms and Conditions</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content common-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <button class="btn btn-info" @click="goback()">
                  <!-- <i class="fa fa-filter"></i> -->
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <h3></h3> -->
        <!-- <p>
Protecting our customers’ privacy is an important priority at Carnival and we are committed to maintaining h3 and meaningful privacy protections. The privacy of your information is a significant responsibility and we value the trust you place in us.
Our Privacy Policy is designed to inform you about the information we collect, how we use it, and your options regarding certain uses of this information.
This policy applies to all website visitors, app users, customers, buyers and users (collectively called as "Users"). In addition, this Privacy Policy applies to all products and services provided by Carnival. By accepting the Privacy Policy and the Terms & Conditions during registration, you expressly consent to our collection, storage, use and disclosure of your personal information as described in this Privacy Policy.
          </p> -->

        <ol>
          <li>
            Subscriber has to provide necessary documents and information to
            establish subscriber’s identification, legal status and business
            capacity. Carnival shall have the right to examine the same.
          </li>
          <li>
            Carnival shall have the right to temporary disconnect, suspend or
            terminate the services for giving any false information by the
            subscriber in any document or otherwise including on the
            subscription form. If there is any change in the information given
            earlier, Subscriber shall notify Carnival of such change, failure of
            which shall entitle Carnival to suspend or terminate the services
            and its sole discretion.
          </li>
          <li>
            Both parties undertake that any information received by one party
            marked as confidential shall be kept as confidential by the other
            party. Such information can be revealed if it is found that it was
            already in the public domain or it was already available to the
            receiving party without violating this agreement or if it is
            required by law.
          </li>
          <li>
            Carnival has the exclusive right and jurisdiction of the title and
            ownership of the connection and equipment (ONU & Wifi Router or any
            other) provided by Carnival.
          </li>
          <li>
            Carnival shall provide the services to the subscriber within agreed
            timeline. However, in case of any delay, Carnival will notify the
            subscriber as soon as it is reasonably practicable.
          </li>

          <li>
            Carnival shall not be liable for disruption and discontinuation of
            its service due to any disturbance, congestion, severance in the
            other networks reasons beyond its control.
          </li>

          <li>
            Carnival may temporarily suspend the services wholly or in parts for
            repair, maintenance, upgrading or circumstances beyond Carnival
            control. However, Carnival will notify the subscriber as soon as it
            is reasonably practicable.
          </li>

          <li>
            Carnival have the right to suspend or terminate the connection
            without further notice in case of subscriber uses the device/
            terminal/ IP on any resources provided by Carnival beyond the
            allocated number of connections or bandwidth capacity.
          </li>

          <li>
            The connection will be automatically disconnected from Carnival if
            the subscriber has exceeded the monthly data volume limit.
          </li>

          <li>
            Carnival should have exclusive right to change/ increase/ reduce the
            traffic charges, validity period, package plans and any other agreed
            terms etc. at any time subject to official notification of such
            changes. No notification will require if such changes take place due
            to any regulatory or government imposition.
          </li>

          <li>
            Carnival may keep the subscriber updated about any new information
            about the Carnival services, if needed. Carnival reserves the right
            to communicate any of its offer and services related communication
            and/or massage to the subscriber at any time and in any manner to
            keep the subscriber updated from time to time. Carnival reserves the
            right to use the name of the subscriber in its material for
            promotion or business purpose.
          </li>

          <li>
            Carnival shall endeavor to provide the best possible service to its
            subscribers. However, the quality, reliability and the availability
            of service may dependent on various factors. In case of failure to
            achieve desired quality, reliability and the availability of service
            due to any of the above factors, Carnival shall not be held liable.
          </li>

          <li>
            The subscriber undertakes not to use Carnival services to commit any
            unlawful act which might endanger national, social or economic
            interest or damage Carnival reputation to other subscriber. Under
            such circumstances, Carnival shall have the exclusive right to
            discontinue the services of the subscriber and take appropriate
            legal measures. Subscriber shall indemnify Carnival if it suffers
            any losses, damages or has to pay any penalty due to unlawful usage
            of the subscriber.
          </li>

          <li>
            Notwithstanding anything contained in this agreement, any other
            information through Carnival brochure, notification, published and/
            or shall broadcasted by Carnival regarding its services, service
            price, billing policy, credit policy etc. shall also be binding to
            this agreement.
          </li>

          <li>
            Use of Carnival services is subject to its more current applicable
            usage policies.
          </li>

          <li>
            Subscriber shall pay agreed charges to Carnival in its prescribed
            bill format strictly within due date. Carnival have right to suspend
            or terminate the connection to the subscriber if the bill is not
            paid in full within due date.
          </li>
          <li>
            Subscribers shall have to pay “Shifting Charge” for shifting the
            connection.
          </li>
          <li>
            Subscriber shall be entitled to reconnect his/her connection by
            making payment of his/her outstanding in full if the connection of
            the subscriber has been suspended, temporarily or permanently
            disconnected due to payment default. If the connection has been
            permanently disconnected by the Carnival for such circumstances,
            along with the full payment of the outstanding bill, the subscriber
            shall also be liable to pay the reconnection fee if applicable.
          </li>

          <li>
            Carnival will retain the ownership of all optical network equipment
            provided to the subscriber. In case of termination or temporary stop
            of services, subscriber shall handover the equipment to Carnival
            without any delay. For any damages to the equipment, subscriber
            shall compensate the value of the damage equipment.
          </li>

          <li>
            Carnival has no control over the accuracy or appropriateness of any
            information in the internet and the subscriber is solely responsible
            for the internet usage.
          </li>

          <li>
            The subscriber undertakes to safeguard the equipment provided by
            Carnival from potential damage (i.e. misusage, negligence, fire,
            lightening, natural disaster, theft, sabotage, come in contact with
            water, drop from height). Carnival shall have the right to ask for
            damages from the subscriber.
          </li>

          <li>
            Carnival shall not be liable for any health hazard or problems
            otherwise caused by the use or abuse of the services and the
            equipment.
          </li>

          <li>
            Subscriber shall solely be responsible for his/her own and his/her
            subscriber’s illegal data or voice transfer or traffic or bulk
            e-mail spamming or any other illegal operation. The sending of bulk
            e-mail spamming is strictly forbidden and the subscriber account
            will be immediately terminated. Subscriber shall indemnify Carnival
            if it suffers any losses, damages or has to pay any penalty due to
            unlawful usage of the subscriber.
          </li>

          <li>
            Subscriber shall install proper electric connection, power grounding
            UPS, stabilizer etc. in his/her premises and on his/her accord.
            Subscriber shall not relocate or move any equipment provided by
            Carnival without the permission of Carnival.
          </li>

          <li>
            Carnival shall not install any product/ services, without authentic
            document from the signatory of this document and authorized
            representative of Carnival and also clearance from the revenue
            assurance department of the Carnival.
          </li>

          <li>
            Without customers written request/ consent for any upgrade /
            downgrade of the bandwidth or any other changes will not be
            executed. For increasing/ decreasing bandwidth, temporarily/
            permanently disconnection needed one month prior written notice.
          </li>

          <li>
            The subscriber shall file its complain about the services of
            Carnival to the subscriber customer care.
          </li>

          <li>
            The subscriber is not authorized to resell {{ companyName }}
            services without written permission and will be liable for legal
            action to be taken if the subscriber is found in doing so.
          </li>

          <li>
            Veterans of Bangladesh Armed Forces will be able to enjoy 25% less
            on the Golden Jubilee of Bangladesh’s independence for their
            lifelong service in uniform rendered to the nation! To avail this
            offer, veterans need to submit their valid TS number at the time of
            registration or online purchase. Our service delivery team will
            collect the photocopy of veterans' ID with TS numbers during
            connecting their homes with {{ companyName }}. Photocopy of the
            veteran's ID card is an essential document to activate the
            especially offered privilege. Veterans can also refer the same to
            their tenants where a recommendation letter duly signed by the
            veterans and photocopy of veteran ID will also be considered as an
            essential document. {{ companyName }} exclusively preserves the
            right to withdraw any offer at any time.
          </li>

          <li>
            Responsibilities of {{ companyName }} are explicitly stated in this agreement
            in this agreement.
          </li>

          <li>
            Notwithstanding anything to the contrary contained herein, Carnival
            shall not be liable for any reason or any representation, implied
            warranty or condition or other term, at lawful or under the terms of
            this agreement for any losses, whether loss/ profit, actual or
            consequential or otherwise and whether occasioned by the Carnival or
            its employees or agents or otherwise relating to the sale of the
            products and/or provision of services to the subscriber.
          </li>

          <li>
            Carnival reserves the right to change the above terms and
            conditions.
          </li>
        </ol>

        <h4>Contact us</h4>
        <p>
          If you have questions, concerns or suggestions related to our Privacy
          Policy or our privacy practices you may write to us at
          <a href="mailto:info@carnival.com.bd"> info@carnival.com.bd </a>
          or Uday Tower, Level 12, 57 &#38; 57/A, Gulshan Avenue, Dhaka-1212.
        </p>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "DataUsage",
  metaInfo: {
    title: "Ticket History | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    fields: {
      current_password: "",
      new_password: "",
      retype_password: "",
    },
    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),
  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }
    // this.api_url = '/admin_users';
    // this.getUsageData();
    // // this.getOrganization();
    // this.$root.$on('sort-data', () => {
    //   this.$root.$emit('show-icon');
    //   this.getUsageData();
    // });
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },

    OpenTicket() {
      let _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/open-ticket";
          let method = "POST";
          console.log(this.ticket);
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.is_loading = false;
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              //alert("Error happend!");
              // console.log("Errors:::", errors);
              //console.log("Errors:::", response);
              console.log(errors.response.data);
              _this.$setErrorsFromResponse(errors.response.data);
              //   _this.$setErrorsFromResponse(errors.response.data.errors);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
        }
      });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getUsageData() {},

    getUsers() {},

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },
  },
};
</script>
